import { useMemo } from 'react';
import { Trans } from '@lingui/macro';
import { Divider, Flex, Stack, Text } from '@mantine/core';
import currency from 'currency.js';
import { observer } from 'mobx-react-lite';

import { calcTariffTotalPrice } from '../../domains/buy-ticket/calc-price/calc-tariff-price';
import { TDiscountRules } from '../../domains/buy-ticket/types';
import { UiCard } from '../ui/ui-card/ui-card';

type CalculatedTariff = {
  id: number;
  price: number;
  discountRules: TDiscountRules[] | null;
  count: number;
};

export const TicketsPrice = observer(
  ({
    selectedTariffs,
    tripStartTime,
  }: {
    tripStartTime: string;
    selectedTariffs: CalculatedTariff[];
  }) => {
    const calculation = useMemo(() => {
      let sum = 0;
      let quantity = 0;

      selectedTariffs
        .filter(({ count }) => count !== 0)
        .forEach(({ count, price, discountRules }) => {
          const tariffTotalPrice = calcTariffTotalPrice({
            tariff: { discountRules, price },
            tripStartTime,
          });

          console.log({ tariffTotalPrice: tariffTotalPrice.value, price });

          sum = currency(tariffTotalPrice).multiply(count).add(sum).value;
          quantity = currency(count).add(quantity).value;
        });

      return { sum, quantity };
    }, [selectedTariffs, tripStartTime]);

    return (
      <>
        <UiCard>
          <Stack>
            <Flex justify="space-between" align="center">
              <Text span size="xl" fw={700}>
                {/* {calculation.quantity} {plurTickets(calculation.quantity)}
                 */}
                <Trans>Сумма</Trans>:
              </Text>
              <Text span size="xl" fw={700}>
                {calculation.sum} ֏
              </Text>
            </Flex>
            <Divider />
            <Text span size="sm">
              {/* <Trans>
                При возврате группового билета возврату подлежат все места.
                Возврат отдельного места не производится.
              </Trans> */}
              {/* <br /> */}
              <Trans>
                После оплаты Вам будет доступен QR-код. Покажите его сотруднику
                ЮКЖД в поезде на просьбу предъявить билет для проверки
              </Trans>
            </Text>
          </Stack>
        </UiCard>
      </>
    );
  }
);
